import { useQuery } from '@apollo/client'
import { LEARNING_PATHS_COUNT, TDataLearningPathsCount } from 'graphqlAPI'

export const useHasLearningPaths = () => {
  const { data, loading } =
    useQuery<TDataLearningPathsCount>(LEARNING_PATHS_COUNT)
  return !loading && !!data?.learningPaths.nodesCount
}
